<template>
  <div>
    <el-card shadow="never" style="margin-bottom: 15px;">
      <div class="d-flex align-items-center" style="overflow:hidden;">
        <div class="header-wrapper">
          <div class="header-icon" />
        </div>
        <div class="flex-1 ml-2">
          <h5 style="color: #101010;">
            {{
              baseInfo.custName ||
                $l('form_label_addOrder') ||
                '新增客户大货订单'
            }}
          </h5>
          <p style="font-size:14px;color: #6C6C6C;" class="m-0 text-truncate">
            <span>
              No：{{
                baseInfo.evgBulkOrderNo ||
                  $l('form_label_evgBulkOrderNoAutoGen') ||
                  '大货订单编号自动生成'
              }}
            </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                baseInfo.evgBulkOrderStatus === 'Y'
                  ? 'success'
                  : baseInfo.evgBulkOrderStatus === 'D'
                  ? 'danger'
                  : ''
              "
            >
              {{ baseInfo.v_evgBulkOrderStatus || 'New' }}
            </el-tag>
            <el-divider direction="vertical" />
            <span>
              Modify：{{ baseInfo.modifyByName || '--' }} at
              {{ baseInfo.modifyDate || '--' }}
            </span>
          </p>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="info-card">
      <div class="switch-tabs_wrappers mb-4">
        <div class="switch-tabs">
          <div
            v-for="item in switchTabs"
            :key="item.value"
            class="switch-tabs_items"
            :class="{
              active: item.value === activeName,
              disabled: item.disabled,
            }"
            @click="!item.disabled ? (activeName = item.value) : () => {}"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>

      <div v-show="activeName === 'order'">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :evgBulkOrderCode="evgBulkOrderCode"
          @loaded="(d) => (baseInfo = d)"
        />

        <div class="d-flex justify-content-end mt-4" v-if="!disabled">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="$refs.editForm.save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-show="activeName === 'doc'">
        <OrderDoc :disabled="disabled" :evgBulkOrderCode="evgBulkOrderCode" />
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import OrderDoc from '../components/order-doc'
export default {
  name: 'ecom-evgBiz-evgBulkOrder-detail',
  components: { EditForm, OrderDoc },
  data() {
    return { baseInfo: {}, activeName: 'order' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    evgBulkOrderCode() {
      return this.params.evgBulkOrderCode
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_order') || '订单信息',
          value: 'order',
        },
        {
          label: this.$l('switchTabs_label_doc') || '客户订单文件',
          value: 'doc',
          disabled: !this.evgBulkOrderCode,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.header-wrapper {
  width: 60px;
  height: 60px;
  min-width: 60px;
  background-image: url('./polygonal.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  .header-icon {
    width: 30px;
    height: 30px;
    background-image: url('./document.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 20px 4px 16px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 35px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    border-bottom: 3px solid #1989fa;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
    border-bottom: 3px solid #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .info-card .el-card__body {
    padding-top: 0;
  }
}
</style>
